// extracted by mini-css-extract-plugin
module.exports = {"imageWithIconText":"SideImageWithInfoCards_imageWithIconText__w5tfo","infoContent":"SideImageWithInfoCards_infoContent__lsS3n","content2":"SideImageWithInfoCards_content2__mvP1m"};